import TextInput from "components/Common/TextInput"
import React from "react"
import { Input, Label, Table } from "reactstrap"
import "./style.css"

export default function FormTrousers({ form, handleChangeInput }) {
  /**
   * todo: di mapping dinamis dengan array
   */
  return (
    <div className="mt-5">
      <h3>トラウザーズ</h3>
      <Table>
        <thead>
          <tr>
            <th>トラウザーズ</th>
            <th>調整(cm)</th>
            <th></th>
            <th colSpan={2}>上がり（cm）</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ width: 150 }}>ウエスト</td>
            <td style={{ width: 150 }}>
              <TextInput
                value={form.pantsWaistAdjustment || ""}
                onChange={handleChangeInput}
                name="pantsWaistAdjustment"
              />
            </td>
            <td>
              <Input
                name={"pantsWaist"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.pantsWaist}
                defaultChecked={form.pantsWaist === "つめ"}
              />
              <Label>つめ</Label>
              <Input
                name={"pantsWaist"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.pantsWaist}
                defaultChecked={form.pantsWaist === "出し"}
              />
              <Label>出し</Label>
            </td>
            <td style={{ width: 55 }}></td>
            <td style={{ width: 150 }}>
              <TextInput
                value={form.pantsWaistRise || ""}
                onChange={handleChangeInput}
                name="pantsWaistRise"
              />
            </td>
          </tr>
          <tr>
            <td>ヒップ</td>
            <td>
              <TextInput
                value={form.hipAdjustment || ""}
                onChange={handleChangeInput}
                name="hipAdjustment"
              />
            </td>

            <td>
              <Input
                name={"hip"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.hip}
                defaultChecked={form.hip === "つめ"}
              />
              <Label>つめ</Label>
              <Input
                name={"hip"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.hip}
                defaultChecked={form.hip === "出し"}
              />
              <Label>出し</Label>
            </td>
            <td style={{ width: 55 }}></td>
            <td>
              <TextInput
                value={form.hipRise || ""}
                onChange={handleChangeInput}
                name="hipRise"
              />
            </td>
          </tr>
          <tr>
            <td>尻先</td>
            <td>
              <TextInput
                value={form.buttocksAdjustment || ""}
                onChange={handleChangeInput}
                name="buttocksAdjustment"
              />
            </td>

            <td>
              <Input
                name={"buttocks"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.buttocks}
                defaultChecked={form.buttocks === "つめ"}
              />
              <Label>つめ</Label>
              <Input
                name={"buttocks"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.buttocks}
                defaultChecked={form.buttocks === "出し"}
              />
              <Label>出し</Label>
            </td>
            <td style={{ width: 55 }}></td>
            <td>
              <TextInput
                value={form.buttocksRise || ""}
                onChange={handleChangeInput}
                name="buttocksRise"
              />
            </td>
          </tr>
          <tr>
            <td>股下</td>
            <td>
              <TextInput
                value={form.inseamAdjustment || ""}
                onChange={handleChangeInput}
                name="inseamAdjustment"
              />
            </td>

            <td>
              <Input
                name={"inseam"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.inseam}
                defaultChecked={form.inseam === "つめ"}
              />
              <Label>つめ</Label>
              <Input
                name={"inseam"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.inseam}
                defaultChecked={form.inseam === "出し"}
              />
              <Label>出し</Label>
            </td>
            <td style={{ width: 55 }}></td>
            <td>
              <TextInput
                value={form.inseamRise || ""}
                onChange={handleChangeInput}
                name="inseamRise"
              />
            </td>
          </tr>
          <tr>
            <td>裾口</td>
            <td>
              <TextInput
                value={form.cuffAdjustment || ""}
                onChange={handleChangeInput}
                name="cuffAdjustment"
              />
            </td>
            <td>
              <Input
                name={"cuff"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.cuff}
                defaultChecked={form.cuff === "シングル"}
              />
              <Label>シングル</Label>
              <Input
                name={"cuff"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.cuff}
                defaultChecked={form.cuff === "ダブル"}
              />
              <Label>ダブル</Label>
              <Input
                name={"cuff"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.cuff}
                defaultChecked={form.cuff === "タタキ"}
              />
              <Label>タタキ</Label>
            </td>
            <td style={{ width: 55 }}>幅</td>
            <td>
              {/* <Label>幅</Label> */}
              <TextInput
                value={form.cuffRise || ""}
                onChange={handleChangeInput}
                name="cuffRise"
              />
            </td>
          </tr>
          <tr>
            <td>膝幅</td>
            <td>
              <TextInput
                value={form.kneeWidthAdjustment || ""}
                onChange={handleChangeInput}
                name="kneeWidthAdjustment"
              />
            </td>

            <td>
              <Input
                name={"kneeWidth"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.kneeWidth}
                defaultChecked={form.kneeWidth === "つめ"}
              />
              <Label>つめ</Label>
              <Input
                name={"kneeWidth"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.kneeWidth}
                defaultChecked={form.kneeWidth === "出し"}
              />
              <Label>出し</Label>
            </td>
            <td style={{ width: 55 }}></td>
            <td>
              <TextInput
                value={form.kneeWidthRise || ""}
                onChange={handleChangeInput}
                name="kneeWidthRise"
              />
            </td>
          </tr>
          <tr>
            <td>裾幅</td>
            <td>
              <TextInput
                value={form.hemWidthAdjustment || ""}
                onChange={handleChangeInput}
                name="hemWidthAdjustment"
              />
            </td>

            <td>
              <Input
                name={"hemWidth"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.hemWidth}
                defaultChecked={form.hemWidth === "つめ"}
              />
              <Label>つめ</Label>
              <Input
                name={"hemWidth"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.hemWidth}
                defaultChecked={form.hemWidth === "出し"}
              />
              <Label>出し</Label>
            </td>
            <td style={{ width: 55 }}></td>
            <td>
              <TextInput
                value={form.hemWidthRise || ""}
                onChange={handleChangeInput}
                name="hemWidthRise"
              />
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  )
}
